// API configuration
export const API_CONFIG = {
  // Base URL for API requests
  baseURL: '',
  
  // Default request timeout in milliseconds
  timeout: 180000, // 180 seconds default to match backend
  
  // Default headers
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  
  // Retry configuration
  retry: {
    retries: 3,
    initialDelayMs: 1000,
    maxDelayMs: 5000,
  },
  
  // Cache configuration
  cache: {
    enabled: true,
    maxAge: 5 * 60 * 1000, // 5 minutes
    excludePaths: ['/imports', '/events', '/indicators'],
  },
  
  // Rate limiting
  rateLimit: {
    maxRequestsPerMinute: 60,
    enabled: true,
  },
  
  // Logging configuration
  logging: {
    level: import.meta.env.DEV ? 'debug' : 'error',
    // Enable verbose logging in development so we can see auth/login requests
    enabled: import.meta.env.DEV,
  },
};
